
import UiAudioPlayer from './UiAudioPlayer.vue'

import Vue from 'vue'


class AudioPlayer{
  constructor(){
    this.vueInstance=null;
  }

  // creating new modal with ok and cancel button
  load(url){
  
    return new Promise((resolve)=>{
      this.vueInstance= new Vue({
        render: h => h( UiAudioPlayer,{
          props:{
            url:url
          },
          on:{
            close:() => { this.close(resolve)},
          }
        })
      }).$mount();
      document.body.appendChild(this.vueInstance.$el);

    });
  }


  // ok button clicked
  close(resolve){
    document.body.removeChild(this.vueInstance.$el);
    this.vueInstance=null;
    resolve();
  }


}

// exporting 'singleton' here
export let audioPlayer = new AudioPlayer();